import { Component } from '@angular/core';

@Component({
  selector: 'app-gradient-wise-drop-table',
  templateUrl: './gradient-wise-drop-table.component.html',
  styleUrls: ['./gradient-wise-drop-table.component.scss']
})
export class GradientWiseDropTableComponent {

}
